// src/pages/About.tsx
import React from 'react';  
import './BookClubPage.css';
import BookClubCard from '../../components/BookClubCard/BookClubCard'; // Import the BookClubCard component
import ImageBook from '../../assets/Images/bookclub/1.png'; 
import ImageBook2 from '../../assets/Images/bookclub/2.png'; 
import ImageBook3 from '../../assets/Images/bookclub/3.png'; 

const BookClubPage: React.FC = () => { 

  return (
    <div className="book-club-container">
  <div className="ctitle-container-courses">
        <h1 className="courses-title">Book Club</h1>
        <h1 className="bookclub-subtext">Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa. Sagittis magna porta tristique ac leo a. Nulla sit tincidunt sociis suspendisse.</h1>
      </div>
      <BookClubCard 
      author="Alexandra Safron" 
      date="May 15, 2025" 
      title="How to Stop Worrying and Start Living" 
      description="Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa." 
      imageSrc={ImageBook} 
    />
     <BookClubCard 
      author="Alexandra Safron" 
      date="May 15, 2025" 
      title="How to Stop Worrying and Start Living" 
      description="Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa." 
      imageSrc={ImageBook2} 
    />
     <BookClubCard 
      author="Alexandra Safron" 
      date="May 15, 2025" 
      title="How to Stop Worrying and Start Living" 
      description="Lorem ipsum dolor sit amet consectetur. Diam elit aliquam senectus semper accumsan tortor scelerisque massa." 
      imageSrc={ImageBook3} 
    />
    </div>
  );
};

export default BookClubPage;
